import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

export const useElementIconStyles = makeStyles((theme: Theme) => ({
    iconStart: {
        color: theme.palette.primary.main,
        width: "16px !important",
        height: "16px !important",
    },
    iconStartSecondary: {
        color: theme.palette.posIcon.main,
        width: 16,
        height: 16,
    },
    iconOrganization: {
        color: theme.palette.posIcon.main,
        width: 18,
        height: 18,
    },
}));
